import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import DistLogin from "../DistributorLogin/DisLogin";

export default function Routerpage() {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/login" component={DistLogin} />
        </Switch>
      </Router>
    </>
  );
}
